/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.parentElement;
      // If already open, close it; otherwise close others and open this one
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      } else {
        document.querySelectorAll('.faq-item').forEach(faq => faq.classList.remove('active'));
        item.classList.add('active');
      }
    });
  });

/* ---- Electric Operator Kit rule ----
 * The kit is not sold on its own. It is hidden as a standalone "Operator" choice on product pages,
 * and automatically added to the cart (same quantity) whenever a motor operator is added. */
(function () {
  var KIT_ID = 50709606039749, KIT = 'Electric Operator Kit', MOTOR = /Shedmaster|EasyRoller|Hiro/i, t;
  function hide() {
    document.querySelectorAll('.SizeSwatch__Radio[value="' + KIT + '"]').forEach(function (i) { (i.closest('li') || i.parentElement).style.display = 'none'; });
    document.querySelectorAll('.Popover__Value[data-value="' + KIT + '"], .VariantSelector__Item[data-option-value="' + KIT + '"]').forEach(function (b) { b.style.display = 'none'; });
  }
  function schedule() { clearTimeout(t); t = setTimeout(hide, 50); }
  hide();
  document.addEventListener('DOMContentLoaded', hide);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('product:added', function (e) {
    var d = e.detail || {}; if (d.eoKitHandled) return;
    var v = d.variant || {}, title = [v.title, v.option2, v.option1, v.option3].filter(Boolean).join(' ');
    if (!MOTOR.test(title)) return;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: KIT_ID, quantity: d.quantity || 1 }] }) })
      .then(function () { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .catch(function () {});
  });
})();
